module.exports = __webpack_public_path__ + "static/media/error.09f839c4.png";